import React, { useState } from 'react';
import { useRouter } from 'next/router';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import EcoEmail from 'eco-design/elements/eco-email';
import { needTermsCheckLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';

import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { t } = useLang('theProduct.SectionA');
    const { locale }: any = useRouter();

    const CONTACT_LIST_ID: any = {
        eu: '926148913',
        uk: '2109435518',
        de: '1061412141',
        fr: '774048908',
        it: '1152966046',
        es: '1399480182',
        us: '1272859510',
        ca: '250347439',
    };
    const contactListId = [`${CONTACT_LIST_ID[locale]}`];
    const SUB_SOURCE = 'WEB_NEW_PRODUCT_SUB';

    const productTitle = t('label1');
    const SITE_ID: any = {
        eu: '4427',
        uk: '4430',
        de: '4425',
        fr: '4428',
        it: '4429',
        es: '4426',
        us: '4423',
        ca: '4424',
    };

    const OptInOverride: any = {
        eu: true,
        uk: true,
        it: true,
        fr: true,
        es: true,
        de: true,
        us: false,
        ca: false,
    };
    const DateIds: any = {
        eu: '9690',
        uk: '9690',
        it: '9690',
        fr: '9690',
        es: '9690',
        de: '9690',
        us: '12555',
        ca: '12555',
    };
    const ProductIds: any = {
        eu: '7596',
        uk: '7596',
        it: '7596',
        fr: '7596',
        es: '7596',
        de: '7596',
        us: '11150',
        ca: '11150',
    };

    const WaveValues: any = {
        eu: ['45'],
        uk: ['45'],
        it: ['45'],
        fr: ['45'],
        es: ['45'],
        de: ['45'],
        us: ['12'],
        ca: ['12'],
    };
    const GlacierValues: any = {
        eu: ['43'],
        uk: ['43'],
        it: ['43'],
        fr: ['43'],
        es: ['43'],
        de: ['43'],
        us: ['13'],
        ca: ['13'],
    };

    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;

    const changeOptions = !!needTermsCheckLocales.includes(locale as string)
        ? [{ id: DateIds[locale], type: 'text', value: dateString, overwrite: false }]
        : [{ id: '9690', type: 'multiple', value: ['12'], overwrite: false }];

    const fields = [
        // 站点字段
        {
            id: SITE_ID[locale],
            type: 'single',
            value: 1,
            overwrite: true,
        },
        // Opt-In
        {
            id: '31',
            type: 'single',
            value: 1,
            overwrite: OptInOverride[locale],
        },
        // 产品字段
        {
            id: ProductIds[locale],
            type: 'multiple',
            value: WaveValues[locale],
            overwrite: false,
        },
        // 产品字段
        {
            id: ProductIds[locale],
            type: 'multiple',
            value: GlacierValues[locale],
            overwrite: false,
        },
        ...changeOptions,
    ];

    const productList = [
        {
            value: 'EcoFlow WAVE 3',
            label: 'EcoFlow WAVE 3',
            checked: true,
            fields: [
                // 站点字段
                {
                    id: SITE_ID[locale],
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                // Opt-In
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: OptInOverride[locale],
                },
                // 订阅日期
                // {
                //     id: DateIds[locale],
                //     type: 'text',
                //     value: dateString,
                //     overwrite: true,
                // },
                // 产品字段
                {
                    id: ProductIds[locale],
                    type: 'multiple',
                    value: WaveValues[locale],
                    overwrite: false,
                },
                ...changeOptions,
            ],
        },
        {
            value: 'EcoFlow GLACIER Classic',
            label: 'EcoFlow GLACIER Classic',
            checked: true,
            fields: [
                // 站点字段
                {
                    id: SITE_ID[locale],
                    type: 'single',
                    value: 1,
                    overwrite: true,
                },
                // Opt-In
                {
                    id: '31',
                    type: 'single',
                    value: 1,
                    overwrite: OptInOverride[locale],
                },
                // 订阅日期
                // {
                //     id: DateIds[locale],
                //     type: 'text',
                //     value: dateString,
                //     overwrite: true,
                // },
                // 产品字段
                {
                    id: ProductIds[locale],
                    type: 'multiple',
                    value: GlacierValues[locale],
                    overwrite: false,
                },
                ...changeOptions,
            ],
        },
    ];
    return (
        <div className={`eco-content ${styles.comp}`} id="subscription-products-section">
            <EcoSpace />
            <div className="comp-box">
                <EcoImg
                    pc="https://websiteoss.ecoflow.com/upload/image/1744440396715/email.jpg"
                    h5="https://websiteoss.ecoflow.com/upload/image/1744440396165/email_h5.jpg"
                    className="comp-bg"
                />
                <div className="comp-msg">
                    {/* <div className="comp-msg-title">{t('title')}</div> */}
                    <div className="comp-msg-title">
                        {t.rich('title', {
                            highlight: (text: string) => <span className="highlight">{text}</span>,
                        })}
                    </div>
                    <EcoEmail
                        contactListId={contactListId}
                        productTitle={productTitle}
                        productList={productList}
                        source={SUB_SOURCE}
                        fields={[]}
                        defaultTermsCheck={!!needTermsCheckLocales.includes(locale as string)}
                    />
                </div>
            </div>
        </div>
    );
}
